import { render, staticRenderFns } from "./MttosComponent.vue?vue&type=template&id=0ff09ca8&"
import script from "./MttosComponent.vue?vue&type=script&lang=js&"
export * from "./MttosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports